export default "__VITE_ASSET__DNuCUKHg__"